"use client";

import styled from "styled-components";
import Input from "../input";
import Icon from "@/components/icon";

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const IconComponent = styled(Icon)`
  position: absolute;
  left: 15px;
  top: 50%;
  margin-top: -9px;

  svg {
    transition: 0.3s easy-out;
    stroke: var(--borderGraySearch);
    width: 18px;
    height: 18px;
  }
`;

export const InputComponent = styled(Input)`
  border: 1px solid var(--borderGraySearch);
  height: 36px;
  min-width: 256px;
  border-radius: 100px;
  box-shadow: none !important;
  padding-left: 40px;
  padding-right: 15px;
  background: var(--whiteGray);
  font-family: "Roboto Light";
  font-size: 15px;
  color: var(--textLight);
  height: 42px;

  &:focus {
    border-color: var(--primarySystem);
  }

  &::placeholder {
    color: var(--placeholderColor);
  }
`;
